import React, { useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useStateWithDebounce, Lab, useGetLogFiles } from '@modmd/data'
import { useSortChangeHandler } from 'utils/helpers'
import DashboardPage from 'internal-portal/sharedComponents/DashboardPage'
import { Box, Container } from 'components/Layout'
import { useSearchState } from 'internal-portal/utils/useSearchState'
import { SelectInput } from 'components/SelectInput'
import { DateInput } from 'components/DateInput'
import { DEVICE } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import { ReportsLogsDatalist } from 'sharedComponents/ReportsLogsDatalist'
import { LAB_OPTIONS } from '../TestSessions/utils'

type FilterState = {
  lab?: Lab | null
}

const ReportsLogs: React.VFC<RouteComponentProps> = () => {
  const isMobile = !useIsMinDevice(DEVICE.TABLET)
  const searchState = useSearchState<FilterState>()
  const { sorter, handleSortChange } = useSortChangeHandler()
  const [searchDate, setSearchDate] = useState(new Date())

  const { data: reportLogs, loading: reportsLoading } = useGetLogFiles({
    filter: {
      date: searchDate,
      lab: searchState.data.lab?.length ? searchState.data.lab : undefined,
      gmt: new Date().getTimezoneOffset(),
    },
  })

  const [filterData, setFilterData] = useStateWithDebounce<FilterState>({}, (filter) => {
    searchState.setSearchState({ ...filter }, false, true)
  })

  const handleInputChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const { value, name } = event.target
      setFilterData({ ...filterData, [name]: value })
    },
    [filterData, setFilterData]
  )

  return (
    <DashboardPage>
      <Container>
        <ReportsLogsDatalist
          logs={reportLogs?.getLogFiles || []}
          isLoading={reportsLoading}
          tableHeader={
            <Box
              display="grid"
              gridGap="1rem"
              gridTemplateColumns={
                isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(13rem, max-content))'
              }
            >
              <DateInput
                id="date"
                name="date"
                label="Date"
                value={searchDate}
                onChange={(date) => {
                  setSearchDate(date ?? new Date())
                }}
                hasBottomContent={false}
                isFullWidth
              />
              <SelectInput
                name="lab"
                label="Lab"
                value={filterData.lab || ''}
                onChange={handleInputChange}
                options={LAB_OPTIONS}
                hasBottomContent={false}
              />
            </Box>
          }
          sorter={sorter}
          onSortChange={handleSortChange}
          requestDebounceInMs={250}
        />
      </Container>
    </DashboardPage>
  )
}

export default ReportsLogs
